// extracted by mini-css-extract-plugin
export default {"legend":"Legend_legend__0ClrL","wordSpacing":"Legend_wordSpacing__Z6Wua","fullView":"Legend_fullView__7Raw-","shimmer":"Legend_shimmer__wIW2h"};